import { FormValidationDefinition } from "../../../../../common/components/form/use-form";
import mileageDictionaryUpdateFormValidationService from "./mileage-dictionary-update-form-validation.service";
import MileageDictionaryUpdateFormData from "./types/mileage-dictionary-update-form-data";

const getDefaultFormData = (): MileageDictionaryUpdateFormData => {
  return {
    name: undefined,
    active: true,
  };
};

const getValidationDefinition =
  (): FormValidationDefinition<MileageDictionaryUpdateFormData> => {
    return {
      name: (values) =>
        mileageDictionaryUpdateFormValidationService.validateName(values.name),
      active: (values) =>
        mileageDictionaryUpdateFormValidationService.validateActive(
          values.active,
        ),
    };
  };

const mileageDictionaryUpdateFormHelper = {
  getDefaultFormData,
  getValidationDefinition,
};

export default mileageDictionaryUpdateFormHelper;
